import axios from '@/axios';

// URL and endpoint constants
const INDEX_URL = '/choose_building_blocks/1';

export default {
  index(succ) {
    axios.get(INDEX_URL)
      .then((response) => { succ(response); });
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/buldingBlocks.js